<template>
<router-view :key="$route.fullPath"/>
</template>

<script>
export default {
  name: 'FloristLayout'
}
</script>
<style>
@import "../assets/css/common.css";
</style>
